import { useEffect } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Dialog, Typography } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './video-modal.css';
import { APP_TEXT } from '../../const/app-text';
import { useBreakpoint } from '../../hooks/utils/use-breakpoint';

const pageText = APP_TEXT.pages.landingPage.demoVideo;

export interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoSrc: string;
}

const VideoModal = ({ isOpen, onClose, videoSrc }: VideoModalProps) => {
  const isLgXlDown = useBreakpoint('lgxl', 'down');

  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (!rootElement) return;
    rootElement.style.filter = isOpen ? 'blur(4px)' : '';
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    // p-dialog-content is injected by PrimeReact after render, so we need a short delay
    const timer = setTimeout(() => {
      const content = document.querySelector('.videoModal .p-dialog-content');
      if (content) {
        content.setAttribute('tabindex', '0');
        content.setAttribute('aria-label', pageText.label);
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      header={
        <div className="video-extra-info-wrapper">
          <Typography
            variant="body.small"
            className="video-extra-info-text"
            tabIndex={0}
          >
            Video info
          </Typography>
          <Tooltip
            target=".video-extra-info"
            className="custom-tooltip"
          />
          <i
            className="video-extra-info pi pi-envelope p-text-secondary p-overlay-badge fa-solid fa-info-circle"
            data-pr-tooltip={`Music: ${pageText.music.value}\nArtist: ${pageText.artist.value}\nLicense: ${pageText.licenseCode.value}`}
            data-pr-position="right"
            data-pr-at="right+5 top"
            data-pr-my="left center-2"
            style={{ fontSize: '0.8rem', cursor: 'pointer' }}
          ></i>
        </div>
      }
      maxWidth={isLgXlDown ? 'md' : 'lg'}
      className="videoModal"
    >
      <div
        className="videoModalWrapper"
        role="region"
        aria-label="Video Modal"
      >
        <div className="videoModalContent">
          <video
            controls
            className="videoPlayer"
            autoPlay
          >
            <source src={videoSrc} />
            <track
              src="/captions/captions.en.vtt"
              kind="subtitles"
              srcLang="en"
              label="English"
              default
            />
          </video>
        </div>
      </div>
    </Dialog>
  );
};

export default VideoModal;